module.exports = __webpack_public_path__ + "img/logo-sm.10166a95.png";